import { ComponentType } from "react";
import ShareClipboard from "./share-variants/ShareClipboard";
import ShareDownload from "./share-variants/ShareDownload";
import ShareIMessage from "./share-variants/ShareIMessage";
import ShareInstagramDM from "./share-variants/ShareInstagramDM";
import ShareInstagramStory from "./share-variants/ShareInstagramStory";
import ShareShare from "./share-variants/ShareShare";
import { ValidShareOption } from "./types";

const DefaultShareComponentLookup = {
	ShareClipboard: ShareClipboard,
	ShareDownload: ShareDownload,
	ShareIMessage: ShareIMessage,
	ShareInstagramDM: ShareInstagramDM,
	ShareInstagramStory: ShareInstagramStory,
	ShareShare: ShareShare,
} satisfies Record<ValidShareOption["key"], ComponentType<any>>;

export default DefaultShareComponentLookup;
